import React from 'react';
import PropTypes from 'prop-types';
import Mask from 'react-input-mask';
import NumberFormat from 'react-number-format';
import MaskedInput from 'react-maskedinput';
import './style.scss';

const Input = React.forwardRef((props, ref) => {
    const {
        value,
        onFocus,
        onChange,
        onBlur,
        mask,
        isError,
        type = 'text',
        placeholder,
        name,
        id,
        message,
        label,
        autoFocus,
        readOnly,
        fixedLabel,
        beforeMaskedValueChange,
        disabled,
        className,
        maskOptions,
        withPadding,
        ...rest
    } = props;

    const [isFocused, setFocus] = React.useState(Boolean(value));

    const onFocusInput = React.useCallback(
        (e) => {
            if (disabled) return;
            setFocus(true);
            if (onFocus) {
                e.preventDefault();
                onFocus(e);
            }
        },
        [setFocus, onFocus, disabled]
    );

    const onChangeInput = React.useCallback(
        (e) => {
            if (disabled) return;
            onChange(e);
        },
        [onChange, disabled]
    );

    const onBlurInput = React.useCallback(
        (e) => {
            if (disabled) return;
            if (e.currentTarget.value) {
                setFocus(true);
            } else {
                setFocus(false);
            }
            if (onBlur) {
                onBlur(e);
            }
        },
        [setFocus, onBlur, disabled]
    );

    const classname = `input${isError ? ' input--error' : ''}`;
    const placeholderText = label ? null : placeholder;

    const sharableProps = {
        type,
        placeholder: placeholderText,
        className: `input__input${isFocused || fixedLabel || value ? ' input__input--focused' : ''}${
            className ? ` ${className}` : ''
        }`,
        name,
        id,
        onChange: onChangeInput,
        onBlur: onBlurInput,
        onFocus: onFocusInput,
        value,
        autoFocus,
        readOnly,
        disabled,
        ...rest,
    };

    return (
        <div className={classname}>
            {mask ? (
                <Mask
                    {...sharableProps}
                    beforeMaskedValueChange={beforeMaskedValueChange}
                    mask={mask}
                    // inputRef={node => ref.current = node} для того чтоб не использовать классы везде, где есть Mask
                    inputRef={ref}
                />
            ) : (
                <input {...sharableProps} ref={ref} />
            )}
            {(label || fixedLabel) && (
                <label
                    htmlFor={id}
                    className={value || fixedLabel ? 'focused' : null}
                    style={{ paddingLeft: withPadding ? 10 : 0 }}
                >
                    {fixedLabel || label}
                </label>
            )}
            <span className="input__error">{message}</span>
        </div>
    );
});

Input.propTypes = {
    value: PropTypes.string.isRequired,
    onFocus: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    mask: PropTypes.string,
    isError: PropTypes.bool,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    label: PropTypes.string,
    autoFocus: PropTypes.bool,
    readOnly: PropTypes.bool,
    fixedLabel: PropTypes.string,
    beforeMaskedValueChange: PropTypes.func,
};

export default Input;
export { Input };



// WEBPACK FOOTER //
// ./src/components/input/index.js